import React from 'react';
import Lesson from '../lessons/lesson.jsx';

const AdminLessonSidebar = ({ match }) => {
  return (
    <section className="section is-fullheight admin-activity-sidebar-section">
      <aside className="menu admin-activity-sidebar">
        <Lesson isSidebar={true} location={location} match={match} />
      </aside>
    </section>
  )
}

export default AdminLessonSidebar;
